<template lang="pug">
  .abilityGroup
    p.abilityGroup__title 行動支付
    .abilityGroup__item
      span.abilityGroup__subtitle 行動支付頁面
      BaseAbilityRadioGroup(
        :value="abilityMobilePayment"
        :disabled="disabled"
        @handleRadioChange="setAbilityMobilePayment")
</template>
<script>
import BaseAbilityRadioGroup from '@/components/common/select/BaseAbilityRadioGroup'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      abilityMobilePayment: 'positionStore/getCurrentAbilityMobilePayment',
    }),
  },
  methods: {
    ...mapActions({
      setAbilityMobilePayment: 'positionStore/setAbilityMobilePayment',
    }),
  },
  components: {
    BaseAbilityRadioGroup,
  },
}
</script>
<style lang="scss" scoped>
@import 'src/scss/_abilityGroup';
</style>



// WEBPACK FOOTER //
// src/pages/manager/AbilityRadioGroup/AbilityGroupMobilePayment.vue